
// import React from "react";

// const RazorpayCheckout = () => {
//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handlePayment = async () => {
//     // Ensure the Razorpay script is loaded
//     const isScriptLoaded = await loadRazorpayScript();
//     if (!isScriptLoaded) {
//       alert("Failed to load Razorpay SDK. Please try again later.");
//       return;
//     }

//     try {
//       // Step 1: Create an order by calling your backend
//       const response = await fetch("https://b2bbackendapi.mmstourism.com/create-order", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           amount: 1, // Amount in INR (500 INR)
//           currency: "INR",
//           receipt: "receipt_123", // Replace with your receipt logic
//         }),
//       });

//       const { order } = await response.json();

//       // Step 2: Razorpay options
//       const options = {
//         key: "rzp_live_fyXllJiRnEXPAg", // Replace with your Razorpay Key ID
//         amount: order.amount, // Amount in paise
//         currency: order.currency,
//         name: "Your Company Name",
//         description: "Test Transaction",
//         order_id: order.id, // Order ID created on the backend
//         handler: async function (response) {
//           console.log("Razorpay response:", response);

//           // Step 3: Verify payment on the server
//           const verificationResponse = await fetch("https://b2bbackendapi.mmstourism.com/process-payment", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               order_id: response.razorpay_order_id,
//               payment_id: response.razorpay_payment_id,
//               signature: response.razorpay_signature,
//             }),
//           });

//           const result = await verificationResponse.json();

//           if (result.success) {
//             alert("Payment successful!");
//           } else {
//             alert("Payment verification failed!");
//           }
//         },
//         prefill: {
//           name: "John Doe", // Replace with dynamic user data
//           email: "johndoe@example.com", // Replace with dynamic user data
//           contact: "9999999999", // Replace with dynamic user data
//         },
//         theme: {
//           color: "#528FF0",
//         },
//       };

//       const razorpay = new window.Razorpay(options); // Ensure Razorpay is available
//       razorpay.open();
//     } catch (error) {
//       console.error("Error during payment:", error);
//     }
//   };

//   return (
//     <div>
//       <button onClick={handlePayment} style={{ padding: "10px 20px", fontSize: "16px" }}>
//         Pay Now
//       </button>
//     </div>
//   );
// };

// export default RazorpayCheckout;
import React from "react";

const RazorpayCheckout = ({ userId, amount }) => {
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) return resolve(true);

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    const loaded = await loadRazorpayScript();
    if (!loaded) {
      alert("Razorpay SDK failed to load");
      return;
    }

    try {
      /* ✅ STEP 1: CREATE ORDER */
      const orderRes = await fetch(
        `https://b2bbackendapi.mmstourism.com/api/b2/agency/create-wallet-order/${userId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount }), // INR
        }
      );

      const orderData = await orderRes.json();

      if (!orderData.success) {
        alert("Order creation failed");
        return;
      }

      const { order } = orderData;

      /* ✅ STEP 2: RAZORPAY OPTIONS */
      const options = {
        key: "rzp_live_fyXllJiRnEXPAg", // LIVE key
        amount: order.amount, // paise
        currency: order.currency,
        name: "MMS Tourism",
        description: "Wallet Top-up",
        order_id: order.id,

        handler: async function (response) {
          try {
            /* ✅ STEP 3: VERIFY PAYMENT */
            const verifyRes = await fetch(
              "https://b2bbackendapi.mmstourism.com/api/b2/agency/process-payment",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
                }),
              }
            );

            const verifyData = await verifyRes.json();

            if (verifyData.success) {
              alert("✅ Payment successful & wallet updated");
            } else {
              alert("❌ Payment verification failed");
            }
          } catch (err) {
            console.error("Verification error:", err);
            alert("Payment verification error");
          }
        },

        prefill: {
          name: "Agent User",
          email: "agent@example.com",
          contact: "9999999999",
        },

        theme: {
          color: "#0A2540",
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Payment error:", error);
      alert("Payment failed");
    }
  };

  return (
    <button
      onClick={handlePayment}
      style={{
        padding: "12px 24px",
        fontSize: "16px",
        background: "#0A2540",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
      }}
    >
      Add Money to Wallet
    </button>
  );
};

export default RazorpayCheckout;
